export default __webpack_public_path__ + "static/media/banner.e49d35f9.mp4";